import { render, staticRenderFns } from "./FacebookCampaignListItem.vue?vue&type=template&id=94e28a8a"
import script from "./FacebookCampaignListItem.vue?vue&type=script&lang=js"
export * from "./FacebookCampaignListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports